import React from 'react';
import { motion } from 'framer-motion';
export const About = () => {
  return <section id="about" className="bg-[#0A0A0A] py-32" data-id="element-12">
      <div className="max-w-5xl mx-auto px-6" data-id="element-13">
        <div className="flex flex-col md:flex-row items-center gap-16 md:gap-24" data-id="element-14">
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1
        }} className="w-full md:w-1/2 aspect-[3/4] overflow-hidden" data-id="element-15">
            <img src="https://cdn.magicpatterns.com/uploads/hBjsQjV6JSRVJm5QdCaePD/Hola,_soy_Flavia_✂️Despues_de_muchos_anos_trabajando_en_el_rubro,_hoy_estoy_dando_un_paso_muy_im.jpg" alt="Flavia L Aguirre" className="w-full h-full object-cover object-top opacity-90" data-id="element-16" />
          </motion.div>

          <div className="w-full md:w-1/2 flex flex-col items-center md:items-start text-center md:text-left" data-id="element-17">
            <motion.h2 initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} className="font-serif text-2xl md:text-3xl text-gold tracking-[0.2em] uppercase mb-4 font-light" data-id="element-18">
              Flavia L Aguirre
            </motion.h2>

            <motion.p initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} className="font-cursive text-2xl text-gold mb-12 opacity-80" data-id="element-19">
              Estilista Capilar
            </motion.p>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="font-sans font-light text-offwhite/70 text-sm md:text-base leading-relaxed mb-12" data-id="element-20">
              Especializada en colorimetría artesanal. Me formé para entender
              que cada cabello es único, y que un buen color no es suerte — es
              diagnóstico, técnica y dedicación. En FLA, cada clienta es un
              proyecto.
            </motion.p>

            <motion.div initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} className="border border-gold/30 px-8 py-4" data-id="element-21">
              <p className="font-sans text-gold text-xs tracking-[0.2em] uppercase" data-id="element-22">
                La Blanqueada, Montevideo
              </p>
            </motion.div>
          </div>
        </div>

        <div className="mt-32 flex flex-col md:flex-row-reverse items-center gap-16 md:gap-24" data-id="element-23">
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1
        }} className="w-full md:w-1/2 aspect-[4/5] overflow-hidden" data-id="element-24">
            <video src="https://cdn.magicpatterns.com/uploads/wDXmnWWEVPtng7BvZv7vg5/Todo lo que soñé… hoy tiene forma ✨Este espacio no es solo un salón, es historia, esfuerzo y muc.mp4" className="w-full h-full object-cover opacity-90" autoPlay loop muted playsInline data-id="element-25" />
          </motion.div>

          <div className="w-full md:w-1/2 flex flex-col items-center md:items-start text-center md:text-left" data-id="element-26">
            <motion.h3 initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} className="font-serif text-2xl md:text-3xl text-gold tracking-[0.2em] uppercase mb-8 font-light leading-relaxed" data-id="element-27">
              El Espacio
            </motion.h3>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="font-sans font-light text-offwhite/70 text-sm md:text-base leading-relaxed" data-id="element-28">
              Este espacio no es solo un salón, es historia, esfuerzo y mucha
              dedicación. Cada rincón de FLA fue pensado y diseñado para
              ofrecerte no solo un servicio de excelencia, sino una experiencia
              de lujo y confort.
            </motion.p>
          </div>
        </div>
      </div>
    </section>;
};